<div class="layout-px-spacing mt-5" id="myPdf" *ngIf="deliveryRequest || nid || packingSlip">
  <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
    <!-- Logo Section -->
    <div style="display: flex; align-items: center;">
      <img src="../../../assets/img/icons/logo.png" style="width: 200px;" />
    </div>

    <!-- Bon de Livraison Section -->
    <div style="font-size: 22px; color:#252525; padding: 6px 50px; text-align: center;">
      Bon de livraison N° {{ packingSlip?.nid }}
    </div>
  </div>

  <div style="text-align: center; font-size: 24px; color: #555; margin-bottom: 30px;">
    <span>{{ packingSlip?.pickUpjobRequest?.subDivision }}, {{ packingSlip?.pickUpjobRequest?.city }} > {{
      packingSlip?.dropOffjobRequest.city }}, {{ packingSlip?.dropOffjobRequest.subDivision }}</span>
  </div>
  <div style="display: flex; justify-content: center; align-items: center; gap: 70px; margin-bottom: 40px;">
    <div *ngIf="packingSlip?.pickUpjobRequest?.isExchange"
      style=" width: 180px; height: 70px; display: flex; justify-content: center; align-items: center; font-size: 22px; color: black;">
      Échange: Oui
    </div>
    <div *ngIf="packingSlip?.pickUpjobRequest?.inspectionAllowed"
      style=" width: 180px; height: 70px; display: flex; justify-content: center; align-items: center; font-size: 22px; color: black;">
      Ouvrir Colis? {{packingSlip?.pickUpjobRequest?.inspectionAllowed ? 'Ok' : 'Non'}}
    </div>
    <div *ngIf="packingSlip?.pickUpjobRequest?.fragile"
      style=" width: 180px; height: 70px; display: flex; justify-content: center; align-items: center; font-size: 22px; color: black;">
      Fragile: Oui
    </div>
  </div>

  <div style="overflow-x: auto; margin-bottom: 40px;">

    <div class="packing-slip">
      <div class="grid-container">
        <!-- Expéditeur Section -->
        <div class="expediteur">
          <h3>Expéditeur</h3>
          <p style="font-size: 1.2rem; line-height: 1.5;">{{ packingSlip?.pickUpjobRequest?.business?.nomCommercial }}
          </p>
          <p style="font-size: 1.2rem; line-height: 1.5;">{{ packingSlip?.pickUpjobRequest?.business?.tel }}</p>
          <p style="font-size: 1.2rem; line-height: 1.5;">
            {{ packingSlip?.pickUpjobRequest?.pickUp?.pickUpAddress }},
            {{ packingSlip?.pickUpjobRequest?.city }},
            {{ packingSlip?.pickUpjobRequest?.subDivision }}
          </p>
        </div>

        <!-- Produit Section -->
        <div class="produit">
          <h3>Produit</h3>
          <p style="font-size: 1.2rem; line-height: 1.5;">{{ packingSlip?.pickUpjobRequest?.descProduit }}</p>
          <p style="font-size: 1.2rem; line-height: 1.5;">
            {{ packingSlip?.pickUpjobRequest?.amount }} DT
            <span *ngIf="packingSlip?.pickUpjobRequest?.paymentStatus === 1">(Payé)</span>
          </p>
          <p style="font-size: 1.2rem; line-height: 1.5;"><strong>Chèque:</strong>
            {{ packingSlip?.pickUpjobRequest?.collectedInCheck === 1 ? 'Oui' : 'Non' }}
          </p>
        </div>

        <!-- Client Section -->
        <div class="client">
          <h3>Client</h3>
          <p style="font-size: 1.2rem; line-height: 1.5;">{{ packingSlip?.dropOffjobRequest?.deliveredToName }}</p>
          <p style="font-size: 1.2rem; line-height: 1.5;">{{ packingSlip?.dropOffjobRequest?.deliveredToPhone }}</p>
          <p style="font-size: 1.2rem; line-height: 1.5;">
            {{ packingSlip?.dropOffjobRequest?.city }},
            {{ packingSlip?.dropOffjobRequest?.subDivision }},
            {{ packingSlip?.dropOffjobRequest?.zone }},
            {{ packingSlip?.dropOffjobRequest?.dropOffAddress }},
          </p>
        </div>

        <!-- Montant Section -->
        <div class="montant">
          <h3>Montant TTC</h3>
          <p style="font-size: 1.9rem; line-height: 1.5; color: red;">{{ packingSlip?.pickUpjobRequest?.amount }} DT</p>
        </div>
      </div>
    </div>
  </div>

  <div style="text-align: left;">
    <span>
      Information additionnelle: {{ packingSlip?.pickUpjobRequest?.addInfo}}
    </span>
  </div>
</div>

<iframe class="d-none" frameBorder="0" id="sample-pdf"
  style="right: 0; top: 53px; bottom: 0; height: 400px; width: 100%"></iframe>
